import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import ColorRgbDialog1 from "../twin-widget-dialog/color-rgb-dialog-1";
import { SyncBadge } from "../../common/badges";

const ColorRgb1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [colorRgb, setColorRgb] = useState("#ffffff");
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      setColorRgb(widget.items.$w1.value || "#ffffff");
    }
  }, [widget]);

  const handleValueUpdate = useCallback(
    (data) => {
      if (!widgetData) return;

      const updatedWidget = {
        ...widgetData.items.$w1,
        value: data,
      };

      onValueUpdate([updatedWidget]);
    },
    [widgetData, onValueUpdate]
  );

  const handleRgbUpdate = useCallback(
    (newColor) => {
      if (!newColor) return;
      setColorRgb(newColor);
      handleValueUpdate(newColor);
    },
    [handleValueUpdate]
  );

  if (!widgetData) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>Loading...</div>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "fit-content",
        overflow: "hidden",
      }}
    >
      {pattern && pattern.endsWith("_W") && <SyncBadge />}
      <ColorRgbDialog1
        color={colorRgb}
        onValueUpdate={handleRgbUpdate}
        current="rgb"
        disabled={pattern && pattern.endsWith("_R")}
      />
    </Box>
  );
};

export default ColorRgb1Widget;
